import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../../molecules/RoundedModal'
import SetActiveVersionForm from './form'

const SetActiveVersionDialog = React.forwardRef(function SetActiveVersionDialog ({ blueprint, onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false, version: null })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false, version: null })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (version) => {
      setDialogState({ open: true, processing: false, version: structuredClone(version) })
    }
  }), [setDialogState])

  return (
    <RoundedModal
      title='Set Active Version'
      open={dialogState.open}
      onClose={close}
      size='md'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <SetActiveVersionForm
            blueprint={blueprint}
            version={dialogState.version}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </RoundedModal>
  )
})

SetActiveVersionDialog.propTypes = {
  blueprint: PropTypes.object.isRequired,
  onComplete: PropTypes.func
}

SetActiveVersionDialog.defaultProps = {
  onComplete: () => {}
}

export default SetActiveVersionDialog
